module.exports = __webpack_public_path__ + "static/media/tip_cat_topical.1ec80b1b.png";